import style from "./style.scss";

const Editorial = ({ children }) => (
  <div class={style.editorial}>{children}</div>
);

export default Editorial;
